webpackJsonp([60165779361151],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserTemplate = function UserTemplate(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container text-center' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      data.strapiUser.username
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      data.strapiUser.posts.map(function (post) {
	        return _react2.default.createElement(
	          'li',
	          { key: post.id },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' + post.id },
	              post.title
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            post.content
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = UserTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-user-js-36bf3e5856eec18d514e.js